import {PayloadAction, createSlice} from '@reduxjs/toolkit';
import {RootState} from 'utils';

const initialState: RootState['language'] = {data: ''};

const languageSlice = createSlice({
    name: 'language',
    initialState,
    reducers: {
        setLanguage: (state, {payload}: PayloadAction<string>) => {
            state.data = payload;
        },
    },
});

export const {setLanguage} = languageSlice.actions;

export default languageSlice.reducer;
